import { useMemo } from "react";
import { Route, Routes as RRoutes } from "react-router-dom";

import { useAuth } from "common/hooks/useAuth";
import { useAppConfig } from "common/providers/AppConfigProvider";
import Page404 from "./Page404";
import LicenseBlockedPage from "./LicenseBlockedPage";
import { loginRoutes } from "../routes";

const getUserRoutes = (routes: any, user: any, isLicenceValid: boolean) =>
  routes.map((route: any) => {
    let Component = null;
    Component = route.Component;
    const { path, roles = null, managerRightsKey = null } = route;

    // Check if license blocks access (except for allowed pages)
    // These pages remain accessible even without a valid license
    const allowedPathsWithoutLicense = [
      "/",                    // Home/Dashboard
      "/login",               // Login
      "forgot-password",      // Forgot password
      "/reset-password",      // Reset password
      "/my-account",          // Personal account settings
      "/users",               // User management (to delete users and get back to compliance)
      "/servers",             // License management (to fix license issues)
      "/support",             // Support page
      /* "/parks", */               // Parks (for superadmin)
      "/license-blocked",     // License blocked page itself
    ];

    const isAllowedWithoutLicense = allowedPathsWithoutLicense.some(
      (allowedPath) => path === allowedPath || path?.startsWith(allowedPath + "/")
    );

    if (!isLicenceValid && !isAllowedWithoutLicense) {
      Component = LicenseBlockedPage;
    } else if (roles && roles !== "all") {
      if (user?.role) {
        if (!roles.includes(user.role.name)) {
          Component = Page404;
        } else if (
          ((roles.includes("Manager") && user?.role?.name === "Manager") ||
            (roles.includes("Observer") && user?.role?.name === "Observer")) &&
          managerRightsKey &&
          !user?.administrationPermissions?.[managerRightsKey]?.read
        ) {
          Component = Page404;
        }
      } else {
        return null;
      }
    }

    return <Route key={path} path={path} element={<Component />} />;
  });

function Routes({ routes }: any) {
  const { user, isUserRefreshing }: any = useAuth();
  const { isLicenceValid } = useAppConfig();

  const userRoutes = useMemo(() => {
    if (user) {
      return getUserRoutes(routes, user, isLicenceValid);
    }

    return getUserRoutes(loginRoutes, user, isLicenceValid);
  }, [routes, user, isLicenceValid]);

  return isUserRefreshing ? null : <RRoutes>{userRoutes}</RRoutes>;
}

export default Routes;
